import { render, staticRenderFns } from "./CDRQFileHolder.vue?vue&type=template&id=8c4d6dca&"
import script from "./CDRQFileHolder.vue?vue&type=script&lang=ts&"
export * from "./CDRQFileHolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports